import { useEffect, useState } from 'react';
import { fetchEmailsHead } from '../restapi/messageService';

// eslint-disable-next-line import/prefer-default-export
export const usePostboxCounter = (box: string, trigger: number, filter?: string, contactIds?: number[] | null) => {
  const [count, setCount] = useState<number | null>();

  useEffect(() => {
    if (contactIds !== null) {
      fetchEmailsHead(box, filter, null, contactIds)
        .then((resp) => {
          const total = resp.headers.get('X-Total-Count');
          if (total) {
            setCount(parseInt(total, 10));
          }
        })
        .catch(() => setCount(null));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger, contactIds]);

  return count;
};
